import { motion } from "framer-motion";
import { Fragment, useRef, useState } from "react";
import Image from "next/image";
// import useScrollLock from "@/utils/use-scroll-lock";

export default function Card({ data }) {
  const { image, description, name } = data;
  const [isCardOpened, setIsCardOpened] = useState(false);
  const [cardDimensions, setCardDimensions] = useState({ width: 0, height: 0 });
  const card = useRef(null);
  // useScrollLock(isCardOpened);
  return (
    <Fragment>
      <motion.div
        ref={card}
        layout
        className={`overflow-hidden cursor-pointer rounded-2xl ${
          isCardOpened
            ? "shadow-serviceCard  fixed top-8 left-0 right-0 bottom-0 m-auto z-[20] flex flex-col justify-start p-4 lg:w-[70vw] w-[95vw] md:h-[550px] h-[500px] bg-white overflow-y-auto"
            : "relative"
        }`}
      >
        {isCardOpened && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="absolute lg:top-4 top-3 lg:right-8 right-3 cursor-pointer"
          >
            <Image
              src="/images/cancel.png"
              alt="close"
              className="lg:w-8 w-6"
              onClick={() => {
                console.log("clicked");
                setIsCardOpened(!isCardOpened);
              }}
              width={40}
              height={40}
            />
          </motion.div>
        )}
        <motion.img
          onClick={() => {
            setIsCardOpened(true);
            if (!isCardOpened) {
              setCardDimensions({
                width: card.current.clientWidth,
                height: card.current.clientHeight,
              });
            }
          }}
          src={image}
          alt={name}
          className={` ${
            isCardOpened
              ? "w-[200px] lg:h-[200px] md:h-[200px]"
              : "w-full lg:h-[230px] md:h-[200px]"
          } h-[150px] object-cover rounded-2xl`}
        />
        <div className="flex flex-col w-full">
          <motion.div
            layout="position"
            className={`lg:text-lg md:text-base text-sm font-bold my-2 text-darkBlue`}
          >
            {name}
          </motion.div>

          {isCardOpened && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-sm font-light [&>p]:mb-4 [&>ul]:list-disc [&>ul]:md:text-base [&>ul]:text-sm"
            >
              {description}
            </motion.p>
          )}
        </div>
      </motion.div>
      {isCardOpened && (
        <Fragment>
          <div
            style={{
              width: cardDimensions.width,
              height: cardDimensions.height,
            }}
          ></div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            onClick={() => setIsCardOpened(false)}
            className="fixed inset-0 bg-white rounded-md bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-10 z-10"
          />
        </Fragment>
      )}
    </Fragment>
  );
}
